var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more_wrapper"},[_c('div',{staticClass:"content"},[_c('el-image',{staticStyle:{"width":"100%","height":"335px"},attrs:{"src":require('../assets/imgs/more.png'),"fit":'fit'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }